export default {
  heroEyebrow: "Basetao Spreadsheet Ressourcen-Hub",
  heroH1: "Basetao Spreadsheet — Produkte, Verkäufer & smartere Shopping-Ressourcen finden",
  heroText:
    "Entdecke Basetao Spreadsheet-Ressourcen, Produktrecherche-Guides, Verkäuferinformationen, QC-Tipps, Versand-Guides und praktische Ressourcen, die das Einkaufen in China einfacher recherchierbar machen.",
  heroCta1: "Basetao Spreadsheet",
  heroCta2: "Jetzt kaufen",
  heroTrust: "Unabhängige Ressource · Praktische Recherche · Aktuelle Guides",

  categoriesEyebrow: "Nach Kategorie shoppen",
  categoriesTitle: "Produkte nach Kategorie durchstöbern",
  categoriesText:
    "Wähle unten eine Kategorie, um Produkte, Verkäufer und Spreadsheet-Funde auf der Hauptseite zu entdecken. Jeder Link öffnet sich in einem neuen Tab.",
  dropdownLabel: "Kategorie auswählen",
  dropdownPlaceholder: "Kategorie wählen…",
  dropdownGo: "Öffnen",

  aboutEyebrow: "Was ist das",
  aboutTitle: "Was ist ein Basetao Spreadsheet?",
  aboutP1:
    "Ein Basetao Spreadsheet ist eine von der Community geteilte Liste oder Tabelle mit Produkten, Links, Verkäufernotizen und Qualitätskontroll-Beobachtungen (QC), die von Käufern genutzt werden, die über den Basetao-Agenten bestellen. Diese Tabellen helfen dir, Funde zu vergleichen, zuverlässige Verkäufer zu erkennen und Artikel vor dem Kauf zu recherchieren.",
  aboutP2:
    "Da ein Spreadsheet Hunderte Produktlinks an einem Ort bündelt, verwandelt es eine langsame, zerstreute Suche in eine schnellere, strukturiertere Art, Kleidung, Sneaker, Accessoires und mehr zu recherchieren.",
  aboutP3:
    "Betrachte ein Spreadsheet immer als Ausgangspunkt, nicht als Garantie. Prüfe Preis, Verkäuferbewertung und Versandbedingungen selbst, bevor du bestellst.",

  guidesEyebrow: "Guides & Artikel",
  guidesTitle: "Lies unsere Original-Guides",
  guidesText:
    "Unabhängige, originelle Artikel, die dir helfen, Produkte zu recherchieren, QC zu verstehen und bessere Entscheidungen zu treffen.",
  guide1Title: "Basetao Spreadsheet: Kompletter Anfänger-Guide",
  guide1Text:
    "Was ein Basetao Spreadsheet ist, wie es funktioniert, beliebte Kategorien, QC-Tipps und Versand-Grundlagen — alles, was Einsteiger wissen müssen.",
  guide2Title: "Überblick der Produktkategorien",
  guide2Text:
    "Ein kurzer Rundgang durch die wichtigsten Kategorien, von Sneakern und Hoodies bis zu Taschen und Accessoires.",
  guide3Title: "QC-Fotos richtig lesen",
  guide3Text:
    "Verstehe QC-Fotos, Maße und die Warnsignale, auf die du achten solltest, bevor du einen Artikel freigibst.",
  guide4Title: "Versand-Grundlagen erklärt",
  guide4Text:
    "Wie Versandkosten geschätzt werden, was den Preis beeinflusst und welche Faktoren du zwischen den Linien vergleichen solltest.",
  readMore: "Artikel lesen",

  howEyebrow: "So funktioniert es",
  howTitle: "In vier Schritten smarter recherchieren",
  step1Title: "Finden",
  step1Text: "Entdecke Produkte, Verkäufer und Spreadsheet-Ressourcen an einem Ort.",
  step2Title: "Recherchieren",
  step2Text: "Vergleiche Produkt-, Verkäufer- und QC-Informationen.",
  step3Title: "Prüfen",
  step3Text: "Prüfe Preis, Versand und Bedingungen selbst.",
  step4Title: "Entscheiden",
  step4Text: "Bestelle mit besseren Informationen und weniger Überraschungen.",

  faqEyebrow: "FAQ",
  faqTitle: "Häufig gestellte Fragen",
  faq1Q: "Was ist ein Basetao Spreadsheet?",
  faq1A:
    "Es ist eine von der Community geteilte Liste oder Tabelle mit Produktlinks, Verkäufernotizen und QC-Beobachtungen, die von Käufern genutzt wird, die über den Basetao-Agenten bestellen.",
  faq2Q: "Ist das die offizielle Basetao-Website?",
  faq2A:
    "Nein. Dies ist eine unabhängige Informationswebsite, die weder mit Basetao verbunden noch von Basetao unterstützt wird.",
  faq3Q: "Wie finde ich Produkte auf der Hauptseite?",
  faq3A:
    "Nutze das Kategorie-Dropdown oder die Kategorie-Buttons auf dieser Seite. Jeder Link öffnet die passende Kategorie auf der Hauptseite in einem neuen Tab.",
  faq4Q: "Wie hoch sind die Basetao-Versandkosten?",
  faq4A:
    "Die Versandkosten hängen von Zielort, Gewicht, Maßen und Versandart ab. Prüfe vor der Bestellung immer die aktuellen Preise auf der Hauptseite.",
  faq5Q: "Sind die Produkte garantiert?",
  faq5A:
    "Nein. Ein Spreadsheet oder Produktlink garantiert weder Echtheit, Qualität noch Lieferung. Recherchiere zuerst immer Verkäufer und QC-Informationen.",

  finalCtaTitle: "Starte mit dem Basetao Spreadsheet",
  finalCtaText:
    "Entdecke Produktressourcen, Recherche-Guides, QC-Informationen und Versand-Guides in einem organisierten Hub.",
  finalCtaButton: "Basetao Spreadsheet entdecken",
};